import type { DeviceModelListResponseApi } from '@ingenico/api-sdk-assets-public';
import type { CustomDeviceFamily } from '@ingenico/react-section-utils';

export function mapDeviceFamilyList({ deviceModels }: DeviceModelListResponseApi): CustomDeviceFamily[] {
  return deviceModels;
}
